<input
  #input
  matInput
  [matTooltip]="'LEAD.PLEASE_SELECT_COUNTRY' | translate"
  [tabIndex]="tabIndex"
  [formControl]="inputCtrl"
  [matAutocomplete]="auto"
  [matTooltipDisabled]="!!this.country"
  [readonly]="!this.country"
  (blur)="onBlur()">
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayName"
  [autoActiveFirstOption]="true"
  (optionSelected)="onSelect($event)"
  (closed)="onClosed()">
  <ng-container *ngIf="filteredCities">
    <mat-option *ngFor="let city of filteredCities" [value]="city">{{ ("City." + city.name) | translate}}
      <ng-container *ngIf="city.cityCode"> - {{city.cityCode}}</ng-container>
    </mat-option>
  </ng-container> 
</mat-autocomplete>
<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>
